import {
  Box,
  Grid,
  Pagination,
  PaginationItem,
  styled,
  Typography,
} from "@mui/material";
import { SelectInput } from "components";
import { useSelector } from "react-redux";

const TablePagination = ({
  color,
  page,
  pageSize,
  pageCount,
  handleChangePage,
  handleChangePageSize,
  pageSizeList = [{ name: 5 }, { name: 10 }, { name: 20 }, { name: 50 }],
  hideLastPage = false,
  justifyContent = "space-between",
  siblingCount = 0,
  boundaryCount = 1,
  size = "small",
}) => {
  const userState = useSelector(state => state?.userState);
  const theme = userState?.publisher?.theme_color;

  return (
    <Box p="12px 16px">
      <Grid container justifyContent={justifyContent} alignItems="center" rowSpacing={1} columnSpacing={1}>
        <Grid item>
          {pageSize && (
            <Grid container columnSpacing={1} alignItems="center">
              <Grid item>
                <Typography color="#687083" fontSize="14px">
                  Item per page:
                </Typography>
              </Grid>
              <Grid item>
                <SelectInput
                  onChange={handleChangePageSize}
                  options={pageSizeList}
                  value={pageSize}
                  optionKey="name"
                  optionLabel="name"
                  width="auto"
                />
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid item>
          <StyledPagination
            count={pageCount}
            shape="rounded"
            size={size}
            customColor={color || theme}
            page={page}
            onChange={handleChangePage}
            boundaryCount={boundaryCount}
            siblingCount={siblingCount}
            renderItem={item => {
              const isLastPage =
                item?.type === "page" && item?.page === pageCount;
              const shouldHideLast =
                hideLastPage &&
                pageCount > siblingCount + boundaryCount + 3 &&
                page < pageCount - (siblingCount + 1);
              if (isLastPage && shouldHideLast) {
                return null;
              }
              return <PaginationItem {...item} />;
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

const StyledPagination = styled(Pagination)(({ customColor }) => ({
  "& .MuiButtonBase-root.Mui-selected": {
    backgroundColor: `${customColor || "#111827"}`,
    color: "white",
    "&:hover": {
      backgroundColor: `${customColor || "#111827"}`,
    },
  },
}));
export default TablePagination;
